jQuery(function () {
  if (document.body.classList.contains("block-editor-page")) return;

  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  domReady(() => {
    whenGsapReady(() => {
      whenScrollReady(() => {
        initProductSideFrameGallery();
      });
    });
  });

  function initProductSideFrameGallery() {
    const blocks = document.querySelectorAll(".js-nlp-sfg");
    if (!blocks.length) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    blocks.forEach((block) => {
      if (block.dataset.sfgInit === "1") return;
      block.dataset.sfgInit = "1";

      const sides = block.querySelectorAll(".js-nlp-sfg-side");
      const centerCard = block.querySelector(".nlp-sfg__card");
      const card = block.querySelector(".nlp-sfg__card");
      const overlay = block.querySelector(".nlp-sfg__overlay-text");
      const below = block.querySelector(".nlp-sfg__below");

      const strengthAttr = block.getAttribute("data-parallax");
      const strength = strengthAttr ? parseFloat(strengthAttr) : 260;

      const speedAttr = block.getAttribute("data-parallax-speed");
      const speed = speedAttr ? parseFloat(speedAttr) : 0.8;
      const factor = clamp(1 - speed, 0, 1);

      const measureCenterMid = () => {
        if (!centerCard) return;

        const blockRect = block.getBoundingClientRect();
        const cardRect = centerCard.getBoundingClientRect();
        const mid = cardRect.top + cardRect.height / 2 - blockRect.top;

        block.style.setProperty("--sfg-center-mid", `${mid}px`);
      };

      const computeOffset = (progress) => {
        const p = clamp(progress, 0, 1);
        const t = (p - 0.5) * 2;
        return -(t * strength * factor);
      };

      const applyOffset = (progress) => {
        if (!sides.length) return;
        const off = computeOffset(progress);
        sides.forEach((side) =>
          side.style.setProperty("--sfg-offset", `${off}px`),
        );
      };

      measureCenterMid();
      window.addEventListener("resize", measureCenterMid);

      if (!reduceMotion) {
        const revealTargets = [card, overlay, below].filter(Boolean);

        if (revealTargets.length) {
          gsap.set(revealTargets, { opacity: 0, y: 18 });

          gsap.to(revealTargets, {
            opacity: 1,
            y: 0,
            duration: 0.9,
            ease: "power2.out",
            stagger: 0.08,
            scrollTrigger: ScrollTrigger
              ? {
                  trigger: block,
                  start: "top 82%",
                  once: true,
                }
              : undefined,
          });
        }
      }

      if (!sides.length || reduceMotion) return;

      if (ScrollTrigger) {
        const st = ScrollTrigger.create({
          trigger: block,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
          onRefresh: (self) => {
            measureCenterMid();
            applyOffset(self.progress);
          },
          onUpdate: (self) => applyOffset(self.progress),
        });

        applyOffset(st.progress);
        return;
      }

      let ticking = false;

      const update = () => {
        ticking = false;

        measureCenterMid();

        const rect = block.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const total = rect.height + vh;
        const p = clamp((vh - rect.top) / total, 0, 1);

        applyOffset(p);
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      update();
    });
  }
});
